export const Logo = ({isDark, maxWidth = 150}) => {
    return (
        <img src={!isDark ? '/img/logo.svg' : '/img/logo-dark.png'} style={{maxWidth}}/>
    )
}
